export const API_KEY = "AIzaSyC282PO_WluSb2M6WV2L3yR7tSZo2EJizg";
export default API_KEY;